import type { SlidesLibraryType } from "./store/types";

export const SIDEBAR_ID = "EOBKJelaS6Q30YWJtdhtZ";
export const SLIDES_CONTAINER_ID = "SLLduQoNWevdMMktcEiJZ";
export const SLIDES_LIBRARY_TYPE_KEY = "sd:slides-library-type";

export type RecentlyUsedCategory = Exclude<SlidesLibraryType, "recently-deleted">;
export type RecentlyUsedSavedCategory = Extract<
  RecentlyUsedCategory,
  "user-slides" | "team-slides"
>;

export const RECENTLY_USED_KEYS: Record<RecentlyUsedCategory, string> = {
  "user-slides": "sd:recently-used:user-slides",
  "team-slides": "sd:recently-used:team-slides",
  layouts: "sd:recently-used:layouts",
  templates: "sd:recently-used:templates",
};

export const RECENTLY_USED_SAVED_PAYLOAD_KEYS: Record<
  RecentlyUsedSavedCategory,
  string
> = {
  "user-slides": "sd:recently-used-payload:user-slides",
  "team-slides": "sd:recently-used-payload:team-slides",
};

export const RECENTLY_USED_MAX = 6;

// The master orgs whose slides library is curated and exported — one per
// backend environment (must match `globalSlidesLibraryOrgId` in the backend's
// staging/production configs).
export const GLOBAL_LIBRARY_ORG_IDS = [
  "51c7c20a4cbbfe638918ed9d3d2433aa", // staging
  "091115aac90308240cca6ea4bdb7e47d", // production
];

export const isGlobalLibraryOrg = (orgId: string | undefined): boolean =>
  !!orgId && GLOBAL_LIBRARY_ORG_IDS.includes(orgId);
